import { call, put, takeLatest } from 'redux-saga/effects';

import { InsurancePolicyApi } from '@apis/InsurancePolicyApi';
import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { Pagination } from '@models/Pagination';
import { SagaPayload } from '@utils/typescript';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';

import {
  insurancePoliciesFetch,
  InsurancePoliciesFetchPayload,
  insurancePolicyUsersFetch,
  InsurancePolicyUsersFetchPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';

function* handleInsurancePoliciesFetch({ payload }: SagaPayload<InsurancePoliciesFetchPayload>) {
  const state: StateUpdatePayload = { insurancePolicies: null, pagination: undefined };
  try {
    const [insurancePolicies, pagination] = (yield call(InsurancePolicyApi.getAll, payload)) as [InsurancePolicy[], Pagination];
    state.insurancePolicies = insurancePolicies;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUsersFetch({ payload }: SagaPayload<InsurancePolicyUsersFetchPayload>) {
  const state: StateUpdatePayload = { insurancePolicyUsers: null, pagination: undefined };
  try {
    const [insurancePolicyUsers, pagination] = (yield call(InsurancePolicyUserApi.search, payload)) as [InsurancePolicyUser[], Pagination];
    state.insurancePolicyUsers = insurancePolicyUsers;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePoliciesFetch, handleInsurancePoliciesFetch);
  yield takeLatest(insurancePolicyUsersFetch, handleInsurancePolicyUsersFetch);
}
